module.exports = __webpack_public_path__ + "media/images/sort-default-756e4cd0bda2a78c6e4fb389f98f3e49.svg";